<template>
	<u-banner v-if="unit.control_code == 'banner'"></u-banner>
	<u-coupon v-else-if="unit.control_code == 'coupon'"></u-coupon>
	<u-swiper-product v-else-if="unit.control_code == 'product_recommend'"></u-swiper-product>
	<u-title v-else-if="unit.control_code == 'title'"></u-title>
	<u-video v-else-if="unit.control_code == 'video'"></u-video>
	<u-icon-menu v-else-if="unit.control_code == 'cell_icon'"></u-icon-menu>
	<u-image-menu v-else-if="unit.control_code == 'cell_icon2'"></u-image-menu>
	<u-scroll-product v-else-if="unit.control_code == 'product'"></u-scroll-product>
	<u-scroll-image v-else-if="unit.control_code == 'roll_icon'"></u-scroll-image>
	<u-image-advert v-else-if="unit.control_code == 'img_advert'"></u-image-advert>
	<u-blank v-else-if="unit.control_code == 'separator'"></u-blank>
	<u-link-area v-else-if="unit.control_code == 'link_area'"></u-link-area>
	<u-product-list v-else-if="unit.control_code == 'product_list'"></u-product-list>
	<u-live-list v-else-if="unit.control_code == 'live_list'"></u-live-list>
	<u-bundle-product v-else-if="unit.control_code == 'bundle_product'"></u-bundle-product>
	<u-recommend-product v-else-if="unit.control_code == 'waterfall_flow'"></u-recommend-product>
	<u-channel-banner v-else-if="unit.control_code == 'channel_banner'"></u-channel-banner>
	<u-channel-product v-else-if="unit.control_code == 'channel_product'"></u-channel-product>
</template>

<script>
	import uBanner from '@/submodule/decorate_manage/components/unit/app/banner.vue'
	import uCoupon from '@/submodule/decorate_manage/components/unit/app/coupon.vue'
	import uSwiperProduct from '@/submodule/decorate_manage/components/unit/app/swiper_product.vue'
	import uTitle from '@/submodule/decorate_manage/components/unit/app/title.vue'
	import uVideo from '@/submodule/decorate_manage/components/unit/app/video.vue'
	import uIconMenu from '@/submodule/decorate_manage/components/unit/app/icon_menu.vue'
	import uImageMenu from '@/submodule/decorate_manage/components/unit/app/image_menu.vue'
	import uScrollProduct from '@/submodule/decorate_manage/components/unit/app/scroll_product.vue'
	import uScrollImage from '@/submodule/decorate_manage/components/unit/app/scroll_image.vue'
	import uImageAdvert from '@/submodule/decorate_manage/components/unit/app/image_advert.vue'
	import uBlank from '@/submodule/decorate_manage/components/unit/app/blank'
	import uLinkArea from '@/submodule/decorate_manage/components/unit/link_area.vue'
	import uChannelBanner from '@/submodule/decorate_manage/components/unit/app/channel_banner.vue'
	import uChannelProduct from '@/submodule/decorate_manage/components/unit/app/channel_product.vue'
	import uProductList from './unit/app/product_list.vue'
	import uLiveList from './unit/app/live_list.vue'
	import uBundleProduct from './unit/app/bundle_product.vue'
	import uRecommendProduct from './unit/app/recommend_product.vue'
	
	export default {
		components: {
			uBanner,
			uCoupon,
			uSwiperProduct,
			uTitle,
			uVideo,
			uIconMenu,
			uImageMenu,
			uScrollProduct,
			uScrollImage,
			uImageAdvert,
			uBlank,
			uLinkArea,
			uProductList,
			uLiveList,
			uBundleProduct,
			uRecommendProduct,
			uChannelBanner,
			uChannelProduct
		},
		
		props: {
			unit: Object
		}
	}
</script>

<style>
</style>
